import React, { useContext } from 'react';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import PrivacyLink from '../common/links/PrivacyLink';
import TermsAndConditionsLink from '../common/links/TermsAndConditionsLink';
import ImprintLink from '../common/links/ImprintLink';
import InnoGamesLink from '../common/links/InnoGamesLink';
import CreditsLink from '../common/links/CreditsLink';
import { useTranslation } from 'react-i18next';
import WikiLink from '../common/links/WikiLink';

function FooterLinkList( ) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const { t } = useTranslation('translation');

	const currYear = new Date().getFullYear();
	return (
		<ul>

			{ onelpsParams.footer.copyright.show && (
				<li>
					<span>{ onelpsParams.footer.copyright.copyrightYear }{ currYear }</span>
				</li>
			)}

			{ onelpsParams.footer.showInnogamesLink && (
				<li><InnoGamesLink linkId="page_footer_n/a_text_innogames" /></li>
			)}

			{ onelpsParams.footer.showPrivacy && (
				<li>
					<PrivacyLink
						label={t('footer.privacy')}
						linkId="page_footer_n/a_text_privacy-policy"
					/>
				</li>
			)}

			{ onelpsParams.footer.showTerms && (
				<li>
					<TermsAndConditionsLink
						label={t('footer.terms')}
						linkId="page_footer_n/a_text_terms-and-conditions"
					/>
				</li>
			)}

			{ onelpsParams.footer.showImprint && (
				<li>
					<ImprintLink
						label={t('footer.legal')}
						linkId="page_footer_n/a_text_legal-notice"
					/>
				</li>
			)}

			{ onelpsParams.footer.credits.show && (
				<li>
					<CreditsLink
						label={t('footer.credits')}
						linkId="page_footer_n/a_text_credits"
						linkUrl={ onelpsParams.footer.credits.link }
					/>
				</li>
			)}

			{ onelpsParams.footer.showWiki && (
				<li>
					<WikiLink />
				</li>
			)}
		</ul>
	);
}

export default FooterLinkList;